import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { LanguageSelector } from './components/LanguageSelector';
import { MatrixRain } from './components/MatrixRain';
import { LandingPage } from './pages/LandingPage';
export function App() {
  return <LanguageProvider data-id="element-0">
      <MatrixRain data-id="element-1" />
      <LanguageSelector data-id="element-2" />
      <LandingPage data-id="element-3" />
    </LanguageProvider>;
}